import './NavigationSubSection.scss';
import * as React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import slugger from 'github-slugger';
type Props = {
  path: string;
  page: {
    name: string;
    slug: string;
    path: string;
  };
  currentPageHeadings: Array<{
    value: string;
    depth: number;
  }>;
  currentHeading: string | undefined | null;
};
type State = {
  expanded: boolean;
};
export default class NavigationSubsection extends React.Component<
  Props,
  State
> {
  slugs = new slugger();
  isCurrent = () => this.props.path === this.props.page.path;
  state = {
    expanded: this.isCurrent(),
  };
  handleSectionClicked = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (this.isCurrent()) {
      event.preventDefault();
      this.setState({
        expanded: !this.state.expanded,
      });
      return false;
    }
  };
  render() {
    this.slugs.reset();
    const { page, currentPageHeadings, currentHeading } = this.props;
    const { expanded } = this.state;
    const isCurrent = this.isCurrent();
    return (
      <li className="NavigationSubsection">
        <Link
          to={page.path}
          onClick={this.handleSectionClicked}
          className={classnames('NavigationSubsection-row', {
            'NavigationSubsection-row--current': isCurrent,
          })}
        >
          {page.name}
        </Link>

        {isCurrent && expanded && (
          <ul className="NavigationSubsection-subsections">
            {currentPageHeadings.map((heading, index) => {
              const slug = this.slugs.slug(heading.value, false);
              return (
                <li
                  key={index}
                  className={classnames('NavigationSubsection-subsection', {
                    'is-current': currentHeading === slug,
                  })}
                >
                  <Link
                    to={`${page.path}#${slug}`}
                    className={classnames(
                      'NavigationSubsection-subsection-link',
                      {
                        'is-current': currentHeading === slug,
                      },
                    )}
                  >
                    {heading.value}
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </li>
    );
  }
}
